module.exports = __webpack_public_path__ + "media/images/projet_03-7455f66098a55ad9022b7348c0fa65a1.jpg";